import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const LoaderContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
}));
